import request from '@/axios/index.js'
const uri = "/user/pay/";
export function findExpenseTenantPage(data) {
    return request.axios({
        type:"get",
        data:data,
        url: uri + 'findExpenseTenantPage'
    })
}
export function findToPayList(data) {
    return request.axios({
        data:data,
        url: uri + 'findToPayList'
    })
}
export function findPayAlreadyList(data) {
    return request.axios({
        data:data,
        url: uri + 'findPayAlreadyList'
    })
}
// 查询祺信兑付列表
export function pagingGldInfList(data) {
  return request.axios({
      data:data,
      url: '/user/buyrPym/pagingGldInfList'
  })
}
// 保存兑付凭证
export function addPayVoucher(data) {
  return request.axios({
      data:data,
      url: '/pay/addPayVoucher'
  })
}
// 更新兑付凭证
export function updatePayVoucher(data) {
  return request.axios({
      data:data,
      url: '/pay/updatePayVoucher'
  })
}
// 删除兑付凭证
export function deletePayVoucher(id,data) {
  return request.axios({
    type:"get",
    data:data,
    url: `/pay/deletePayVoucher/${id}`,
    cache:"no-cache"
  })
}
// 查询兑付凭证
export function queryPayVoucherByGldId(id,data) {
  return request.axios({
    type:"get",
    data:data,
    url: `/pay/queryPayVoucherByGldId/${id}`,
    cache:"no-cache"
  })
}
// 兑付凭证提交审批
export function applyPayVoucherApprove(data) {
  return request.axios({
      data:data,
      url: '/pay/applyPayVoucherApprove'
  })
}





// WEBPACK FOOTER //
// ./src/api/pay.js